import * as React from "react";
import { connect } from "react-redux";
import * as Redux from "redux";
import '../styles/headerStyling.scss';

import { ActivityNavbar, getParameterByName } from '../../Shared';
import { updateSessionOnFirebase } from "../actions/session";

interface HeaderProps {
  session: {
    passage: any;
    timeTracking: { [key: string]: number };
  };
  dispatch: Redux.Dispatch<any>;
}

const Header: React.FC<HeaderProps> = ({ session, dispatch }) => {
  const firebaseSessionID = getParameterByName('student', window.location.href);

  const goToLMS = () => {
    window.location.href = `${window.postbuildEnv.DEFAULT_URL}`;
  };

  const handleSaveAndExit = () => {
    if (firebaseSessionID) {
      const { passage, timeTracking } = session;
      dispatch(updateSessionOnFirebase(firebaseSessionID, { passage, timeTracking }, goToLMS));
    } else {
      goToLMS();
    }
  };

  return (
    <ActivityNavbar
      onSaveAndExit={handleSaveAndExit}
      toolName="proofreader"
    />
  );
};

const mapStateToProps = (state: any) => ({
  session: state.session
});

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>) => ({
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
